module.exports = __webpack_public_path__ + "img/2_107.06f46780.png";